import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { routers } from "./routes";

import { ErrorBoundary } from "@highlight-run/react";
// import { H } from "highlight.run";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";

// @ts-ignore
import "moment/dist/locale/pt-br";
import "react-toastify/dist/ReactToastify.css";

import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/700.css";

moment.defineLocale("pt-br", {});

const App = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  // if (import.meta.env.VITE_APP_ENV === "production") {
  //   H.init("4d7jz0jd", {
  //     serviceName: "frontend-app",
  //     tracingOrigins: true,
  //     networkRecording: {
  //       enabled: true,
  //       recordHeadersAndBody: true,
  //       urlBlocklist: [
  //         "https://www.googleapis.com/identitytoolkit",
  //         "https://securetoken.googleapis.com",
  //         "https://api.mercadopago.com",
  //         "https://sdk.mercadopago.com",
  //       ],
  //     },
  //   });
  // }

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="pt-br">
          <RouterProvider router={routers} />
          <ToastContainer />
        </LocalizationProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
};

export default App;
